// extracted by mini-css-extract-plugin
export default {"info":"screen_info__zcJKV","image":"screen_image__L9J6Y","logos":"screen_logos__Aml57"};